module.exports = __webpack_public_path__ + "static/img/bg-fr.1a9aaea8.webp";